import { useContext } from "react"
import { NotificationContext } from "@context"
import { GET_PREVIEW_EVENT_CANCELLED_EMAIL } from "@graphql"
import { useLazyQuery } from "@apollo/client"

const usePreviewEventCancellationEmail = () => {
  const { notify } = useContext(NotificationContext)

  const [getPreviewEmail, {data, loading, error}] = useLazyQuery(GET_PREVIEW_EVENT_CANCELLED_EMAIL, {
    onError: (error) => notify({ title: "Error", type: "danger", content: `Couldn't preview email`, open: true })
  })

  return {
    getPreviewEmail,
    data,
    loading,
    error,
  }
}

export default usePreviewEventCancellationEmail